import RouteNames from '../constants/route-names';

const route = {
  path: '/',
  redirect: { name: RouteNames.Inspections },
};

export default route;
